module.exports = __webpack_public_path__ + "static/takamol-747820f59b0509991c8376330e6b91d7.mp4";